import { gql } from '@apollo/client'

export const LOGIN_USER_V2 = gql`
  mutation LoginUserV2($credentials: UserCredentials!) {
    login(credentials: $credentials) {
      success
    }
  }
`

export const GET_USER_INFO = gql`
  query GetUserInfo {
    getUserInfo {
      user_id
      role
    }
  }
`

export const REFRESH_USER_ACCESS_TOKEN_V2 = gql`
  mutation RefreshUserAccessTokenV2 {
    refreshToken {
      success
    }
  }
`

export const LOGOUT = gql`
  mutation Logout {
    logout {
      success
    }
  }
`
